import React from "react";
import { useParams } from "react-router-dom";
import Layout, { Breadcrumbs } from "../components/Layout";
import Seo from "../components/Seo";
import { PAGES } from "../data/pages";
import NotFound from "./NotFound";

export default function InfoPage({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const page = PAGES[slug];

  if (!page) return <NotFound />;

  const crumbs = [
    { name: "Home", path: "/" },
    { name: page.crumb, path: page.path },
  ];

  return (
    <Layout>
      <Seo
        title={page.title}
        description={page.description}
        path={page.path}
        breadcrumb={crumbs}
      />
      <Breadcrumbs items={crumbs} />

      <article className="mx-auto max-w-3xl px-4 py-5">
        <h1 className="mb-4 text-2xl font-extrabold text-[#10161f] sm:text-3xl">
          {page.h1}
        </h1>

        {page.comingSoon && (
          <div
            data-testid="coming-soon-badge"
            className="mb-4 inline-block rounded-full bg-[#1ab5a3] px-4 py-1 text-sm font-semibold text-white"
          >
            Updating soon
          </div>
        )}

        <div className="space-y-4 text-[15px] leading-relaxed text-slate-700">
          {page.body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </article>
    </Layout>
  );
}
